import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { MemberAppConfigState } from "@thkStore/Store/Components/MemberAppConfig/MemberAppConfigState";
import { Draft } from "immer";

const initialState: MemberAppConfigState = {
    thkMemberAppUrl: "",
    enableThkMemberAppRedirection: false,
};

const reducer = {
    "Components/MemberAppConfig/SetConfig": (
        draft: Draft<MemberAppConfigState>,
        action: {
            parameter: {
                thkMemberAppUrl: string;
                enableThkMemberAppRedirection: boolean;
            };
        },
    ) => {
        draft.thkMemberAppUrl = action.parameter.thkMemberAppUrl;
        draft.enableThkMemberAppRedirection = action.parameter.enableThkMemberAppRedirection;
    },
};

const memberAppConfigReducer = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).memberAppConfig = memberAppConfigReducer;

export type ApplicationMemberAppConfigState = {
    memberAppConfig: MemberAppConfigState;
} & ApplicationState;

type Reducers = {
    memberAppConfig: typeof memberAppConfigReducer;
};

export type MemberAppConfigActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
